import React, { useState } from 'react';

import { Box, Grid } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import { DataTable, Menu, TablePagination, Typography } from 'shared';
import { paymentPlanStylesTable } from 'components/Inventory/style/style';
import { purchaseTableHeaders } from 'components/Inventory/utils/purchaseTableHeaders';

const PurchaseTable = ({ data, handleDelete }) => {
    const classes = paymentPlanStylesTable();

    const [page, setPage] = useState(1);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);

    const handleSetAnchorEl = (event, row) => {
        setAnchorEl(event.currentTarget);
        setSelectedRow(row);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };
    return (
        <Grid container>
            <Grid item xs={12}>
                <DataTable
                    data={data.slice((page - 1) * 10, page * 10)}
                    headCells={purchaseTableHeaders()}
                    canEdit={true}
                    setAnchorEl={handleSetAnchorEl}
                />
            </Grid>
            <Menu
                anchorEl={anchorEl}
                handleClose={handleCloseMenu}
                items={[
                    {
                        name: (
                            <Box display={'flex'} alignItems={'center'}>
                                <DeleteOutlineIcon color="error" />
                                &nbsp;&nbsp;
                                <Typography text="Delete" sx={classes.deleteText} />
                            </Box>
                        ),
                        onClick: () => {
                            if (selectedRow) {
                                handleDelete(selectedRow.id);
                                handleCloseMenu();
                            }
                        },
                    },
                ]}
            />

            <Grid item xs={12} marginTop="10px">
                <TablePagination
                    page={page}
                    count={data.length}
                    onChange={(event, pageNumber) => setPage(pageNumber)}
                />
            </Grid>
        </Grid>
    );
};

export default PurchaseTable;
